
import React, { Fragment, useState } from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ViewListIcon from '@mui/icons-material/ViewList';
import GPAP_Tooltip from "../../../../../../../../../../gpap-lib/components/GPAP_Tooltip";
import Link from "@mui/material/Link";
import { connect } from "react-redux";
import CaButton from '../../../../../../../../../../gpap-lib/components/shared-components/CaButton';
import MappedText from '../../../../../../../../../instand/reports/create-report/shared-components/mapText';


const chromMap = {
    "23": "MT",
    "24": "X",
    "25": "Y"
  };

function IGVLinks(props) {

    const [anchorEl, setAnchorEl] = useState(null);
    const headerConf = [
        { key: "Experiment ID", text: "Experiment ID"},
        { key: "IGV_position", text: "IGV Position"},
        { key: "IGV_region", text: "IGV Region"},
    ];

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;



    const renderSamples = () => {


        let origin = window.location.origin;


        let selectedDataRow = props.selected_table_rows.find(s => s.data_type === props.dataType);

        if (selectedDataRow !== undefined) {
            let variantObj = selectedDataRow.data_row;
            if (variantObj.length > 0) {

                let variant = variantObj[0];
                if (props.samples !== undefined && props.samples.length !== 0 && Array.isArray(props.samples)) {
                    return props.samples.map(function (s) {
                        if (variant !== undefined) {

                            let chrom, pos, start, end;

                            if (props.dataType === "CNV") {
                                chrom =  chromMap[String(variant.SV_chrom)] || variant.SV_chrom;
                                start = parseInt(variant.SV_start);
                                end = parseInt(variant.SV_end);

                                let start_pos_res_1 = start - 20;
                                let start_pos_sum_1 = start + 20;
                                let start_positions = start_pos_res_1 + "-" + start_pos_sum_1;

                                let end_pos_res_1 = end - 20;
                                let end_pos_sum_1 = end + 20;
                                let end_positions = end_pos_res_1 + "-" + end_pos_sum_1;

                                let start_pos_res_2 = start - 1000;
                                let start_pos_sum_2 = start + 1000;
                                let start_region = start_pos_res_2 + "-" + start_pos_sum_2;

                                let end_pos_res_2 = end - 1000;
                                let end_pos_sum_2 = end + 1000;
                                let end_region = end_pos_res_2 + "-" + end_pos_sum_2;

                                let sampleOrExperiment = s.sample || s;

                                return <Fragment key={sampleOrExperiment}>
                                    <Grid item lg={4}>
                                        <Link target={"_blank"}
                                            href={origin + "/datamanagement/#/experimentinfo/" + sampleOrExperiment}>{sampleOrExperiment}</Link>
                                    </Grid>
                                    <Grid item lg={4}>
                                        <Grid container direction="column">
                                            <Link target={"_blank"}
                                                href={`${origin}/igvgpap/#/browser/?file=${sampleOrExperiment}&chrom=${chrom}&locus=${start_positions}`}>Start +- 20bp </Link>
                                            <Link target={"_blank"}
                                                href={`${origin}/igvgpap/#/browser/?file=${sampleOrExperiment}&chrom=${chrom}&locus=${end_positions}`}>End +- 20bp </Link>
                                        </Grid>
                                    </Grid>
                                    <Grid item lg={4}>
                                        <Grid container direction="column">
                                            <Link target={"_blank"}
                                                href={`${origin}/igvgpap/#/browser/?file=${sampleOrExperiment}&chrom=${chrom}&locus=${start_region}`}>Start +- 1 kbp</Link>
                                            <Link target={"_blank"}
                                                href={`${origin}/igvgpap/#/browser/?file=${sampleOrExperiment}&chrom=${chrom}&locus=${end_region}`}>End +- 1 kbp</Link>
                                        </Grid>
                                    </Grid>

                                </Fragment>
                            } else {
                                chrom = chromMap[String(variant.chrom)] || variant.chrom;
                                start = parseInt(variant.pos);

                                let res_1 = start - 20;
                                let sum_1 = start + 20;
                                let positions = res_1 + "-" + sum_1;

                                let res_2 = start - 1000;
                                let sum_2 = start + 1000;
                                let region = res_2 + "-" + sum_2;

                                let sampleOrExperiment = s.sample || s;

                                return <Fragment key={sampleOrExperiment}>
                                    <Grid item lg={4}>
                                        <Link target={"_blank"}
                                              href={origin + "/datamanagement/#/experimentinfo/" + sampleOrExperiment}>{sampleOrExperiment}</Link>
                                    </Grid>
                                    <Grid item lg={4}>
                                        <Link target={"_blank"}
                                              href={`${origin}/igvgpap/#/browser/?file=${sampleOrExperiment}&chrom=${chrom}&locus=${positions}`}>+- 20bp </Link>
                                    </Grid>
                                    <Grid item lg={4}>
                                        <Link target={"_blank"}
                                              href={`${origin}/igvgpap/#/browser/?file=${sampleOrExperiment}&chrom=${chrom}&locus=${region}`}>+- 1 kbp</Link>
                                    </Grid>
                                </Fragment>
                            }
                        } else {
                            return null;
                        }
                    })
                } else {
                    return <div><MappedText text={"Samples Information not available"}/></div>
                }
            }
        }
    };


    return (
        <div style={{display:"inline-block"}}>
            <CaButton   
            variant="outlined" 
            onClick={handleClick } 
            text="IGV Browser"
            startIcon={<ViewListIcon/>}
            customStyles={{width:"114px"}}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Box p={2} style={{width: "400px" }}>
                    <Grid container direction={"row"}>
                        <Grid item lg={12}>
                            <div>
                            <img
                                style={{    float: "right", maxWidth: "30px"}}
                                src={"https://avatars.githubusercontent.com/u/11527111?s=200&v=4"}/>
                            </div>
                        </Grid>
                            {headerConf.map(d => { return <Grid item lg={4}>
                                <GPAP_Tooltip title = {d.text} placement= "top" >
                                    <Typography variant={"subtitle1"} style={{fontWeight: "bold"}}> {d.text} </Typography>
                                </GPAP_Tooltip>
                            </Grid>})}

                        {renderSamples()}
                    </Grid>
                </Box>
            </Popover>
        </div>
    );
}

function mapStateToProps (state) {


    if(state.selected_table_rows!==undefined)
    {
        return {
            selected_table_rows: state.selected_table_rows
        }
    }
    else{
        return {selected_table_rows: []}
    }

}

export default connect(mapStateToProps)(IGVLinks);